import { useEffect, useState } from "react"
import { useLocation, useSearchParams } from "react-router-dom"

const Success = () => {
    const location = useLocation()
    const [orderDetails, setOrderDetails] = useState()
    const [showErr, setShowErr] = useState(false)
    const [searchParams] = useSearchParams()


    useEffect(() => {
        let upiObj = {};
        if (searchParams.size) {
            for (const entry of searchParams.entries()) {
                upiObj[entry[0]] = entry[1]
            }
           setOrderDetails((prev)=>({...prev,...upiObj}))
        }
        // fetch(`${process.env.REACT_APP_API_BASE_URL}/pay/transaction/merchant-urls-info?orderId=${upiObj.transactionId}`, { method: "POST" }).then(res => res.json()).then((res) => {
        fetch(`${window.location.origin}/pay/transaction/merchant-urls-info?orderId=${upiObj.transactionId}`, { method: "POST" }).then(res => res.json()).then((res) => {
            if (res?.data == "Failed") {
                // window.open(location.state,"_self")
                setShowErr(true)
            } else {
                let obj = Object.entries(res?.data || {}).reduce((acc, [key, value]) => {
                    if (value) acc[key] = value; 
                    return acc;
                  }, {}) 
                  
                setOrderDetails((prev)=>({...prev, ...obj}))
            }
        })
    }, [searchParams])
    
    return <div className="main-box">
                <div className="Success-box">
                {!showErr && <><h4 className="title">Transaction Success</h4>
                    <div className="orderDetails">
                    <p>Order ID:{orderDetails?.orderId}</p>
                    <p>Transaction ID:{orderDetails?.transactionId}</p>
                </div>
                <button className="back-button" onClick={() => { window.open(orderDetails?.successRedirectionURL, "_self") }}>Back to home</button></>}
            {showErr && <>
                <h4 className="title text-danger">Order Record Not Found</h4></>}
                </div>
            </div>
}

export default Success